export default __webpack_public_path__ + "static/media/09.8b60f15e.jpg";